module.exports = __webpack_public_path__ + "static/tools-resources-photo-02@2x-0376368b264950878b7e12ff3bba522d.jpg";